import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/brands.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '../styles/main.css';
import '../styles/saaspass.css';

import * as angular from 'angular';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-cookie';
import 'angular-loading-bar/build/loading-bar.css';

export const app = angular.module('app', [
    require('angular-cookies'),
    require('angular-resource'),
    require('angular-sanitize'),
    require('@uirouter/angularjs').default,
    require('angular-ui-bootstrap'),
    require('angular-ui-mask'),
    require('angular-translate'),
    require('angular-dynamic-locale'),
    require('angular-http-auth'),
    require('angular-smart-table'),
    require('angular-loading-bar'),
    require('../modules/reverse-ajax'),
]);



// WEBPACK FOOTER //
// ./src/portal/app.js